import React, { useState } from 'react';
import "../styles/global.css";
import logo from '../assets/Karolplank.png'; // This will be overridden by CSS content property

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <div className="topbar-logo">
          <a href="/">
            <img src={logo} alt="Logo advokáta" />
          </a>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? '✖' : '☰'}
        </button>
      </div>

      <nav className={`navbar ${menuOpen ? 'active' : ''}`}>
        <a href="/">Profil</a>
        <a href="/o-mne">O advokátovi</a>
        <a href="/specializacia">Služby</a>
        <a href="/kontakt">Kontakt</a>
      </nav>

      <div className="topbar-right">
        <div className="topbar-contact">
          <a href="mailto:karolplank@gmail.com">karolplank@gmail.com</a>
        </div>
      </div>
    </header>
  );
}